<!-- returns IP and DNS -->
<template>
  <div class="getip-container text-left">
    <div v-if="langde" style="min-height:232px;">
      <p class="p-28">
        Ihre IP-Adresse lautet
        <br />
        <span>
          <strong class="ip">{{ data.ip }}</strong>
        </span>
      </p>
      <span v-if="data.dns!=false">
        <p class="m-p">
          Ihre IP Adresse lautet
          <span class="green ip"> {{ data.ip }} </span>
          und Ihr Reverse DNS ist
          <span class="green ip"> {{ data.dns }}</span>
        </p>
      </span>
      <p v-if="isIPV6(data.ip)">
        Wollen Sie Ihre
        <a class="green" href="https://ipv4.anexia.com/">IPv4-Adresse</a> sehen?
      </p>
      <p>
        View in
        <span class="green pointer" @click="changeLang">English</span>
      </p>
    </div>
    <div v-else style="min-height:232px;">
      <p class="p-28">
        Your IP address is
        <br />
        <span>
          <strong class="ip">{{ data.ip }}</strong>
        </span>
      </p>
      <span v-if="data.dns!=false">
        <p class="m-p">
          Your IP address is
          <span class="green ip">{{ data.ip }}</span>
          and your reverse DNS is
          <span class="green ip">{{ data.dns }}</span>
        </p>
      </span>
      <p v-if="isIPV6(data.ip)">
        Want to see your
        <a class="green" href="https://ipv4.anexia.com/">IPv4 address?</a>
      </p>
      <p>
        Auf
        <span class="green pointer" @click="changeLang">Deutsch</span> anzeigen
      </p>
    </div>
  </div>
</template>

<script>
//import axios from "axios"
export default {
  components: {},
  data() {
    return {
      data: [],
      langde: true
    };
  },
  methods: {
    changeLang: function() {
      if (this.langde === true) {
        this.langde = false;
        document.title = "Your IP address";
        document.getElementById("IP_title").innerHTML = "IP-ADDRESS";
      } else {
        this.langde = true;
        document.title = "Ihre IP Adresse";
        document.getElementById("IP_title").innerHTML = "IP-ADRESSE";
      }
    },
    isIPV6(ip) {
      const regexExp = /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/gi;
      return regexExp.test(ip);
    },
  },
  mounted() {
    let ipMeta = document.querySelector("meta[name=anx_ip]");
    let dnsMeta = document.querySelector("meta[name=anx_dns]");
    let langMeta = document.querySelector("meta[name=lang]");

    if (ipMeta === null && dnsMeta === null) {
      console.log("error");
      // Error handling
      return false;
    }

    ipMeta = ipMeta.getAttribute("value");
    dnsMeta = dnsMeta.getAttribute("value");
    if (ipMeta === null && dnsMeta === null) {
      console.log("error");
      // Error handling
      return false;
    }
    langMeta = langMeta.getAttribute("value");
    if (langMeta === "de") {
      this.langde = true;
    } else {
      this.langde = false;
      document.title = "Your IP address";
      document.getElementById("IP_title").innerHTML = "IP-ADDRESS";
    }

    this.data = { ip: ipMeta, dns: dnsMeta };
  }
};
</script>


<style scoped>
.ip {
  overflow-wrap: break-word;
}

.getip-container a {
  text-decoration: none;
}
.getip-container a:hover {
  color: #77bc1f;
}
.pointer {
  cursor: pointer;
}
.getip-container {
  margin-top: 40px;
}
.m-p {
  margin-top: 30px;
  max-width: 485px;
}
p {
  font-size: 18px;
  line-height: 21.6px;
}
.p-28 {
  font-size: 28px;
  line-height: 38.4px;
}
a {
  font-size: 18px;
}
a:hover {
  font-size: 18px;
}

@media only screen and (max-width: 1024px) {
  .m-p {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}

@media only screen and (max-width: 992px) {
  .m-p {
    margin-top: 30px;
    max-width: 100%;
  }
}

@media only screen and (max-width: 599px) {
  .getip-container {
    margin-top: 22px;
    margin-bottom: 31px;
  }
  .p-28 {
    font-size: 24px;
    line-height: 28.8px;
  }
  p {
    font-size: 16px;
  }
  .m-p {
    margin-top: 20px;
    max-width: 100%;
  }
}
</style>